/**
 * Checks if the application is running in a production environment according to the hostname.
 * @returns {boolean}
 */
 
export const isProdEnvironment = () => window.location.hostname === 'partner.giddyup.io'

/**
 * Checks if the application is running in a development environment according to the hostname.
 * @returns {boolean}
 */
export const isDevEnvironment = () => window.location.hostname === 'localhost'
